/**
 * Section impression names for /wedding-rsvp.
 *
 * Same reasoning as the three sibling pages' `sections.js`: `trackSectionViewed`
 * is section-name-agnostic, but the shared analytics module documents its
 * supported values as a closed set with a named wrapper per value, and that
 * module is vendored byte-identical into invite/ and app/ (guarded by
 * `npm run verify:analytics`). Page-local constants keep the "one owner per
 * string, never a literal at a call site" rule without editing two other apps
 * to instrument a landing-page section.
 *
 * Five impressions, not eleven — the same restraint the siblings exercise. The
 * differentiator the page is really selling (attendance per moment), the
 * pipeline the whole positioning rests on (reply → guest list → headcount →
 * seating), the plan qualifier, the questions and the close. Enough to see
 * where a search visitor stops without turning the funnel report into noise;
 * the editorial sections in between are one continuous argument and splitting
 * them would measure scroll depth, not interest.
 *
 * The sample-invitation offer deliberately has NO entry here: it reuses the
 * existing `invitation_preview` name via `trackInvitationPreviewViewed`, which
 * the homepage pricing card and /digital-wedding-invitation already report for
 * the same URL. One name for one offer is what makes the three comparable.
 */
export const WRS_SECTION = {
  MOMENTS: "wedding_rsvp_moments",
  GUEST_LIST: "wedding_rsvp_guest_list",
  PLAN: "wedding_rsvp_plan",
  FAQ: "wedding_rsvp_faq",
  FINAL_CTA: "wedding_rsvp_final_cta",
};

export default WRS_SECTION;
